/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Open_Project_ButtonInputs */

const en_explorer_info_open_project_button = /** @type {(inputs: Explorer_Info_Open_Project_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Project`)
};

const fr_explorer_info_open_project_button = /** @type {(inputs: Explorer_Info_Open_Project_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le projet`)
};

const de_explorer_info_open_project_button = /** @type {(inputs: Explorer_Info_Open_Project_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offenes Projekt`)
};

const it_explorer_info_open_project_button = /** @type {(inputs: Explorer_Info_Open_Project_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri progetto`)
};

const ru_explorer_info_open_project_button = /** @type {(inputs: Explorer_Info_Open_Project_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открытый проект`)
};

const es_explorer_info_open_project_button = /** @type {(inputs: Explorer_Info_Open_Project_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyecto abierto`)
};

const zh_cn2_explorer_info_open_project_button = /** @type {(inputs: Explorer_Info_Open_Project_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开放项目`)
};

const ja_explorer_info_open_project_button = /** @type {(inputs: Explorer_Info_Open_Project_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトを開く`)
};

const hi_explorer_info_open_project_button = /** @type {(inputs: Explorer_Info_Open_Project_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओपन प्रोजेक्ट`)
};

const pt_pt2_explorer_info_open_project_button = /** @type {(inputs: Explorer_Info_Open_Project_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto Aberto`)
};

/**
* | output |
* | --- |
* | "Open Project" |
*
* @param {Explorer_Info_Open_Project_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_open_project_button = /** @type {((inputs?: Explorer_Info_Open_Project_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Open_Project_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_open_project_button(inputs)
	if (locale === "de") return de_explorer_info_open_project_button(inputs)
	if (locale === "it") return it_explorer_info_open_project_button(inputs)
	if (locale === "ru") return ru_explorer_info_open_project_button(inputs)
	if (locale === "es") return es_explorer_info_open_project_button(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_open_project_button(inputs)
	if (locale === "ja") return ja_explorer_info_open_project_button(inputs)
	if (locale === "hi") return hi_explorer_info_open_project_button(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_open_project_button(inputs)
	return en_explorer_info_open_project_button(inputs)
});